export default {"src":"/_next/static/media/crypto.34de3ecd.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};